import React, { useState } from "react";
import {
  Container,
  Grid,
  TextField,
  Button,
  MenuItem,
  Typography,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import RouteLayout from "../../../Components/Layout/RouteLayout";
import { useUpdateBookServiceMutation } from "../../../../api/financeApi";
import { toast } from "react-toastify";
const UpdateService = () => {
  const navigate = useNavigate();
  const params = useParams();
  const paramData = JSON.parse(params.data);
  const [serviceName, setServiceName] = React.useState(paramData?.serviceName);
  const [total, setTotal] = React.useState(paramData?.total);
  const [pricePerUnit, setPricePerUnit] = useState(paramData?.pricePerUnit);
  const [totalAvailable, setTotalAvailable] = React.useState(
    paramData?.totalAvailable
  );
  const [totalUnavailable, setTotalUnavailable] = React.useState(
    paramData?.totalAvailable
  );
  const [status, setStatus] = React.useState(paramData?.status);
  const [onUpdate, { isLoading }] = useUpdateBookServiceMutation();
  const handleSubmit = async () => {
    try {
      const res = await onUpdate({
        id: paramData?.id,
        serviceName,
        total,
        totalAvailable,
        totalUnavailable,
        pricePerUnit,
        status,
      }).unwrap();
      if (res?.successful === true) {
        toast.success(res?.statusMessage);
        navigate(-1);
      } else {
        toast.error(res?.statusMessage ?? res?.validationErrors.replace(","));
      }
    } catch (err) {
      toast.error(err?.data?.statusMessage);
    }
  };

  return (
    <RouteLayout title="Setup">
      <div className="p-5">
        <div className="flex gap-3 mb-5">
          <div>
            <Typography variant="subtitle1" gutterBottom>
              Service Setup /
            </Typography>
          </div>
          <div>
            <Typography variant="subtitle1" gutterBottom>
              New Setup
            </Typography>
          </div>
        </div>
        <div className="mb-5">
          <Button
            startIcon={<ArrowBackIcon />}
            variant="outlined"
            style={{ marginRight: "10px" }}
            onClick={() => navigate(-1)}
          >
            Back
          </Button>
        </div>
        <div className="bg-[#fff] shadow-md rounded-md py-10">
          <Container maxWidth="md">
            <Typography variant="h5" gutterBottom>
              Create New Service
            </Typography>

            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Typography variant="subtitle1" gutterBottom>
                  Basic Information
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Service Name"
                  fullWidth
                  value={serviceName}
                  onChange={(e) => setServiceName(e.target.value)}
                  required
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  label="Total"
                  fullWidth
                  value={total}
                  onChange={(e) => setTotal(e.target.value)}
                  required
                  type="number"
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  label="Total Available"
                  fullWidth
                  value={totalAvailable}
                  onChange={(e) => setTotalAvailable(e.target.value)}
                  required
                  type="number"
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  label="Total Unavailable"
                  fullWidth
                  value={totalUnavailable}
                  onChange={(e) => setTotalUnavailable(e.target.value)}
                  required
                  type="number"
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  label="Price Per Unit"
                  fullWidth
                  value={pricePerUnit}
                  onChange={(e) => setPricePerUnit(e.target.value)}
                  required
                  type="number"
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  select
                  label="Status"
                  fullWidth
                  value={status}
                  onChange={(e) => setStatus(e.target.value)}
                  required
                >
                  <MenuItem value={1}>Active</MenuItem>
                  <MenuItem value={0}>Inactive</MenuItem>
                  <MenuItem value={2}>Maintenance</MenuItem>
                </TextField>
              </Grid>

              <Grid item xs={12}>
                <Button
                  variant="outlined"
                  style={{ marginRight: "10px" }}
                  onClick={() => navigate(-1)}
                >
                  Cancel
                </Button>
                <Button
                  onClick={handleSubmit}
                  disabled={isLoading}
                  variant="contained"
                  color="primary"
                  type="submit"
                >
                  {isLoading ? "Submitting..." : "Submit"}
                </Button>
              </Grid>
            </Grid>
          </Container>
        </div>
      </div>
    </RouteLayout>
  );
};

export default UpdateService;
